import {observer} from "mobx-react"
import {App} from "./App"
import {VhsDetailPage} from "../page/vhs/VhsDetailPage";
import {VhsOverviewPage} from "../page/vhs/VhsOverviewPage";

const VhsApp = observer(function VhsApp({mode}: {mode: 'overview' | 'detail'}) {
    return <App>
        {mode === 'overview' && <VhsOverviewPage />}
        {mode === 'detail' && <VhsDetailPage />}
    </App>
})

export {
    VhsApp
}
